var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pathUrl === 'home' && _vm.drainageShow === '1')?_c('div',{staticClass:"footer-drainage"},[_c('div',{staticClass:"footer-drainage-con"},[_c('div',{staticClass:"footer-close",on:{"click":_vm.drainageClose}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }